import { render, staticRenderFns } from "./SimpleImagePreview.vue?vue&type=template&id=85cfb62e&scoped=true"
import script from "./SimpleImagePreview.vue?vue&type=script&lang=js"
export * from "./SimpleImagePreview.vue?vue&type=script&lang=js"
import style0 from "./SimpleImagePreview.vue?vue&type=style&index=0&id=85cfb62e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cfb62e",
  null
  
)

export default component.exports